import { render, staticRenderFns } from "./ImageAlbum.vue?vue&type=template&id=5af11474"
import script from "./ImageAlbum.vue?vue&type=script&lang=js"
export * from "./ImageAlbum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports